export default __webpack_public_path__ + "static/media/guns_dark.5bbf654d.png";